customElements.whenDefined('variant-selects').then(() => {
  const Component = customElements.get('variant-selects');

  Component.prototype.updateinv = function (target) {
    var invelm = document.getElementById("invq");
    var invbar = document.getElementById("bariv");
    var cont = document.getElementById("cinv");
    var vid = target.dataset.varId;

    console.log(target);
    if(vstock[vid] > 10  ){
      cont.classList.add("hideinv");
    }
    else {
      cont.classList.remove("hideinv");
      if(invelm){
        invelm.innerHTML = vstock[vid];
      }
      if(invbar){
        var inper = (parseInt(vstock[vid]) / 100) * 100;
        invbar.style.width = inper + '%';
      }
    }
  };
});